import { schema } from 'normalizr'

const takeoutRestaurantSetting = new schema.Entity('takeoutRestaurantSettings')

export default takeoutRestaurantSetting
